import { render, staticRenderFns } from "./ServiceInfoElement.vue?vue&type=template&id=44a3a89b&scoped=true&"
import script from "./ServiceInfoElement.vue?vue&type=script&lang=js&"
export * from "./ServiceInfoElement.vue?vue&type=script&lang=js&"
import style0 from "./ServiceInfoElement.vue?vue&type=style&index=0&id=44a3a89b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a3a89b",
  null
  
)

export default component.exports